import { environment } from "src/environments/environment";

/* Config Class*/
export class ConfigApi {
  public static SERVER_HOST = environment.SERVER_HOST;
  public static SERVER_ATZ_HOST = environment.SERVER_ATZ_HOST;
  public static SERVER_DESIBOX_HOST = environment.SERVER_DESIBOX_HOST;

  public static BASE_URL = ConfigApi.SERVER_HOST + "/api/"; // base url for server

  // URL CONSTANTS
  public static URLS: any = {
    LANGUAGE_URL: "../../assets/i18n/",
    LOGOUT_URL: ConfigApi.BASE_URL + "frekis/users/logout",
    REMOVE_ACCOUNT: ConfigApi.BASE_URL + "frekis/users/remove-account",
    GET_TRANSACTIONS: ConfigApi.BASE_URL + "frekis/stripe/transaction",
    GET_TRANSACTIONS_RECEIPT: ConfigApi.BASE_URL + "frekis/stripe/userReceipt",
    GET_TRANSACTIONS_CSV:
      ConfigApi.BASE_URL + "frekis/v3/cloudPanel/transactionHistory",
    EXPORT_TRANSACTIONS_CSV:
      ConfigApi.BASE_URL +
      "frekis/v3/cloudPanel/transactionHistoryForCSVUpload",
    GET_TRANSACTIONS_PDF:
      ConfigApi.BASE_URL + "frekis/v6/cloudPanel/pdf_report",
    GET_RIDE_HISTORY: ConfigApi.BASE_URL + "frekis/ride/listbyuserid",
    GET_RIDE_HISTORY_LIST:
      ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getOperatorRideHistory",
    LOCK_FALLBACK_HISTORY_LIST:
      ConfigApi.BASE_URL + "frekis/v5/lockFallback/fallback_list",
    GET_LEASE_HISTORY_LIST:
      ConfigApi.BASE_URL + "frekis/v3/cloudPanel/leaseHistory",
    GET_RIDE_HISTORY_DETAILS: ConfigApi.BASE_URL + "frekis/ride/getRideLatLong",
    MY_ASSET_RIDE_HISTORY:
      ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getMyAssetRideHistory",
    MY_ASSET_RIDE_HISTORY_DETAILS:
      ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getRideDetails",
    GET_PURCHASE_HISTORY:
      ConfigApi.BASE_URL + "frekis/v2/package/purchaseHistory",
    GET_NOTIFICATIONS: ConfigApi.BASE_URL + "frekis/notification/get",
    SUPPORT: {
      FAQ: ConfigApi.BASE_URL + "frekis/faq",
      OPERATOR_SUPPORT: ConfigApi.BASE_URL + "frekis/admin/operator_support",
      FEEDBACK: ConfigApi.BASE_URL + "frekis/feedback",
    },
    MY_PROFILE: {
      GET_DETAIL: ConfigApi.BASE_URL + "frekis/users/details",
      PRIVACY: ConfigApi.BASE_URL + "frekis/privacy",
      TERM_AND_CONDITIONS: ConfigApi.BASE_URL + "frekis/termsandcondition",
    },
    MY_ASSETS: ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getOperatorAssets",
    MY_ASSETS_FOR_LEASE:
      ConfigApi.BASE_URL + "frekis/v5/lock/owned_lock_for_lease",
    MY_ASSETS_FOR_LEASE_OPTIMIZED:
      ConfigApi.BASE_URL + "frekis/v5/lock/owned_lock_for_lease_optimized",
    MY_LEASE_DELETE: ConfigApi.BASE_URL + "frekis/v2/package/restore_lock",
    MY_ASSETS_UPDATE_LOCK: ConfigApi.BASE_URL + "frekis/v2/lock/update",
    CREATE_ACCIDENT_REPORT:
      ConfigApi.BASE_URL + "frekis/accident_report/create",
    ADD_MEMEBR_FOR_LOCK: ConfigApi.BASE_URL + "frekis/v2/group/group_shared",
    REMOVE_MEMBER_FROM_LOCK: ConfigApi.BASE_URL + "frekis/v2/group/group_stash",
    SEARCH_MEMEBR_FOR_LOCK:
      ConfigApi.BASE_URL + "frekis/users/group_sharing_search",
    UPDATE_OPERATOR: ConfigApi.BASE_URL + "frekis/operator/update",
    UPDATE_CUSTOMER_REPLY_OPRATOR:
      ConfigApi.BASE_URL + "frekis/v5/customerReview/update",
    GET_LOCK_TYPE: ConfigApi.BASE_URL + "frekis/v2/lock/lock_type",
    EMPLOYEE: {
      LOGIN: ConfigApi.BASE_URL + "frekis/v7/employee/login",
      LIST: ConfigApi.BASE_URL + "frekis/v7/employee/list",
      CREATE: ConfigApi.BASE_URL + "frekis/v7/employee/create",
      UPDATE: ConfigApi.BASE_URL + "frekis/v7/employee/update",
      DELETE: ConfigApi.BASE_URL + "frekis/v7/employee/delete",
      CHANGE_PASSWORD:
        ConfigApi.BASE_URL + "frekis/v7/employee/change-password",
      SET_OPERATING_HOURS:
        ConfigApi.BASE_URL + "frekis/v7/employee/update_operator_timing",
      GET_DETAILS: ConfigApi.BASE_URL + "frekis/v7/employee/business_details/",
    },
    EMPLOYEE_LIST: ConfigApi.BASE_URL + "frekis/v7/employee/listAll",
    ASSIGN_EMPLOYEE_ADVANCE_BOOK:
      ConfigApi.BASE_URL +
      "frekis/v6/advance_booking/assignEmployeeToAdvanceBooking",
    EMPLOYEE_ADVANCE_BOOKING_LIST:
      ConfigApi.BASE_URL + "frekis/v7/employee/assignBookingLists",

    RENT_PACKAGE: {
      LIST: ConfigApi.BASE_URL + "frekis/v2/package/getlist",
      GET_LICENSE_TYPE:
        ConfigApi.BASE_URL + "frekis/v6/license_documents/type_list",
      CREATE: ConfigApi.BASE_URL + "frekis/v2/package/create", //post
      UPDATE: ConfigApi.BASE_URL + "frekis/v2/package/update", //post
      DELETE: ConfigApi.BASE_URL + "frekis/v2/package/delete", //delete method
    },
    LEASE_PACKAGE: {
      LIST: ConfigApi.BASE_URL + "frekis/v2/leasPackage/get",
      CREATE: ConfigApi.BASE_URL + "frekis/v2/leasPackage", //post
      UPDATE: ConfigApi.BASE_URL + "frekis/v2/leasPackage/update", //post
      DELETE: ConfigApi.BASE_URL + "frekis/v2/leasPackage", //delete method
    },
    SALE_PACKAGE: {
      LIST: ConfigApi.BASE_URL + "frekis/v2/salePackage/get",
      CREATE: ConfigApi.BASE_URL + "frekis/v2/salePackage", //post
      UPDATE: ConfigApi.BASE_URL + "frekis/v2/salePackage/update", //post
      DELETE: ConfigApi.BASE_URL + "frekis/v2/salePackage", //delete method
    },
    ADVANCE_BOOKING: {
      CREATE: ConfigApi.BASE_URL + "frekis/v6/advance_booking/create_booking", //post
      // UPDATE: ConfigApi.BASE_URL + "frekis/v6/advance_booking/update", //put
      UPDATE: ConfigApi.BASE_URL + "frekis/v6/advance_booking/updateForCloud", //put
      LIST: ConfigApi.BASE_URL + "frekis/v6/advance_booking/list", //Get
      ADVANCE_LIST:
        ConfigApi.BASE_URL + "frekis/v6/advance_booking/advance_booking_list", //Get
      LOCATION_LIST:
        ConfigApi.BASE_URL + "frekis/v7/bookingLocation/listWithoutPagination",
      DELETE: ConfigApi.BASE_URL + "frekis/v6/advance_booking/delete", //delete
      CATEGORY_LIST: ConfigApi.BASE_URL + "frekis/v6/category/list",
      SUB_CATEGORY_LIST: ConfigApi.BASE_URL + "frekis/v6/sub_category/list",
      PACK_DETAIL: ConfigApi.BASE_URL + "frekis/v6/advance_booking/details/",
      NEXT_NUMBER_QUEUE:
        ConfigApi.BASE_URL + "frekis/v6/booking_queue/next_number_of_queue",
      MANUAL_NUMBER_QUEUE:
        ConfigApi.BASE_URL + "frekis/v6/booking_queue/manual_number_of_queue",
    },
    ALL_QUEUERS: {
      LIST: ConfigApi.BASE_URL + "frekis/v6/booking_queue/view_all_queuers",
    },
    UPCOMING_BOOKING: {
      LIST: ConfigApi.BASE_URL + "frekis/v6/advance_booking/user_purchase_list", //Get
      DELETE: ConfigApi.BASE_URL + "frekis/v6/advance_booking/cancel_purchase", //post
      UPDATE:
        ConfigApi.BASE_URL + "frekis/v6/advance_booking/refund_purchase_amount",
    },
    ADVANCE_UPCOMING_BOOKING: {
      LIST:
        ConfigApi.BASE_URL +
        "frekis/v6/advance_booking/advanceBookingPurchaseListForCloudPanel", //Get
      DELETE: ConfigApi.BASE_URL + "frekis/v6/advance_booking/cancel_purchase", //post
      CSVEXPORT:
        ConfigApi.BASE_URL +
        "frekis/v6/advance_booking/advanceBookingPurchaseListForCloudPanelExportData", //Get
      UPDATE:
        ConfigApi.BASE_URL + "frekis/v6/advance_booking/refund_purchase_amount",
    },
    TRACK_ASSETS: {
      CREATE: ConfigApi.BASE_URL + "frekis/v5/instantLockAccess/create",
      CREATE_FOR_LEASE:
        ConfigApi.BASE_URL + "frekis/v5/instantLockAccess/createForLease",
      LIST_BY_LOCKID:
        ConfigApi.BASE_URL +
        "frekis/v5/instantLockAccess/listByLockId?lock_id=",
      DELETE: ConfigApi.BASE_URL + "frekis/v5/instantLockAccess/deleteAccess/",
      INSTANT_ACCESS:
        ConfigApi.BASE_URL + "frekis/v7/employee/business_details/",
      LIST: ConfigApi.BASE_URL + "frekis/v2/lock/lock_tracking",
      END_RIDE: ConfigApi.BASE_URL + "frekis/v7/ride/end", //post //"frekis/v5/ride/end", //old api
      END_PACK:
        ConfigApi.BASE_URL +
        "frekis/v6/advance_booking_ride/end_purchase_package",
    },
    ASSET_LOCK_LIST: ConfigApi.BASE_URL + "frekis/v2/lock/list",
    //shared ma country=IN&distance=1000&user_id&req_type=shared&latitude&longitute
    //owned ma sme without latlong
    PUT_IN_OPERATION: ConfigApi.BASE_URL + "frekis/operator/account_mode",
    SUBSCRIPTION: ConfigApi.BASE_URL + "frekis/v2/subscription",
    SUBSCRIPTION_PURCHASE:
      ConfigApi.BASE_URL + "frekis/v2/subscription/purchase",
    CANCEL_PLAN: ConfigApi.BASE_URL + "frekis/v2/subscription/cancel",
    DASHBOARD: {
      ALL_GET_PACKAGE:
        ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getPackages_count",
      GET_PACKAGE: ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getPackages",
      GET_SALE_PACKAGE: ConfigApi.BASE_URL + "frekis/v2/salePackage/get",
      GET_LEASE_PACKAGE: ConfigApi.BASE_URL + "frekis/v2/leasPackage/get",
      // GET_LEASE_PACKAGE: ConfigApi.BASE_URL + "frekis/v6/cloudPanel/book_advance_booking_list",
      GET_ADVANCE_LEASE_PACKAGE:
        ConfigApi.BASE_URL + "frekis/v6/advance_booking/package_list",

      GET_RIDES_COUNT:
        ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getRidesCount",
      GET_REVENUE: ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getRevenue",
      GET_RIDES: ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getRides",
      GET_LOCK_COUNT: ConfigApi.BASE_URL + "frekis/v3/cloudPanel/lockCount",
      GET_VENDING_REVENUE:
        ConfigApi.BASE_URL + "frekis/v3/cloudPanel/vendingRevenue",
    },
    PAYMENT: {
      GET_CARDS: ConfigApi.BASE_URL + "frekis/stripe/getCardList",
      DELETE_CARD: ConfigApi.BASE_URL + "frekis/stripe/detachCard",
      ADD_CARD: ConfigApi.BASE_URL + "frekis/stripe/addCard",
      PAY_FOR_SUBSCRIPTION:
        ConfigApi.BASE_URL + "frekis/stripe/create_subscription_operator_plan",
      CREATE_INTENT: ConfigApi.BASE_URL + "frekis/stripe/paymentIntent",
      CONFIRM_INTENT: ConfigApi.BASE_URL + "frekis/stripe/confirmIntent",
      CAPTURE_INTENT:
        ConfigApi.BASE_URL + "frekis/stripe/pendingPaymentCapture",
      EPHEMERAL_KEYS: ConfigApi.BASE_URL + "frekis/stripe/ephemeral_keys",
    },
    PENDING_PAYMENT: ConfigApi.BASE_URL + "frekis/v7/extra_hour/listForCloud",
    PENDING_PAYMENT_UPDATE:
      ConfigApi.BASE_URL + "frekis/v7/extra_hour/updateExtraHoursPayment",
    WAIVER: {
      GET_WAIVER:
        ConfigApi.BASE_URL +
        "frekis/admin/waiverTermsandcondition/getTermsWithBrandByUserId",
      ADD: ConfigApi.BASE_URL + "frekis/admin/waiverTermsandcondition/add",
      UPDATE:
        ConfigApi.BASE_URL + "frekis/admin/waiverTermsandcondition/update",
    },
    COUPONCODE: {
      LIST: ConfigApi.BASE_URL + "frekis/v4/couponCode/lists_of_all_packages",
      CREATE: ConfigApi.BASE_URL + "frekis/v4/couponCode/createCouponForAll",
      UPDATE:
        ConfigApi.BASE_URL +
        "frekis/v4/couponCode/edit_coupon_for_all_packages",
      DELETE: ConfigApi.BASE_URL + "frekis/v4/couponCode/delete",
    },
    COUPON: {
      COUPON_BY_PACKAGE:
        ConfigApi.BASE_URL + "frekis/v4/couponCode/getCouponByPackage",
      LIST: ConfigApi.BASE_URL + "frekis/v4/couponCode/get",
      CREATE: ConfigApi.BASE_URL + "frekis/v4/couponCode/create",
      UPDATE: ConfigApi.BASE_URL + "frekis/v4/couponCode/edit",
      CHECK: ConfigApi.BASE_URL + "frekis/admin/waiverTermsandcondition/update",
      DELETE: ConfigApi.BASE_URL + "frekis/v4/couponCode/delete",
      USED_LIST: ConfigApi.BASE_URL + "frekis/v4/couponCode/list",
    },
    SALE_COUPON: {
      CREATE: ConfigApi.BASE_URL + "frekis/v4/couponCode/createSaleCouponCode",
      UPDATE: ConfigApi.BASE_URL + "frekis/v4/couponCode/editSaleCouponCode",
    },
    LEASE_COUPON: {
      LEASELIST: ConfigApi.BASE_URL + "frekis/v4/couponCode/getLeaseCouponCode",
      CREATE: ConfigApi.BASE_URL + "frekis/v4/couponCode/createLeaseCouponCode",
      UPDATE: ConfigApi.BASE_URL + "frekis/v4/couponCode/editLeaseCouponCode",
    },
    VENDING_COUPON: {
      VENDING_COUPON_LIST: ConfigApi.BASE_URL + "frekis/v7/couponCode/list",
      VENDING_COUPON_CREATE: ConfigApi.BASE_URL + "frekis/v7/couponCode/create",
      VENDING_COUPON_UPDATE: ConfigApi.BASE_URL + "frekis/v7/couponCode/update",
      VENDING_COUPON_DELETE: ConfigApi.BASE_URL + "frekis/v4/couponCode/delete",
    },
    ADVANCE_BOOK_COUPON: {
      LEASELIST: ConfigApi.BASE_URL + "frekis/v4/couponCode/getLeaseCouponCode",
      CREATE:
        ConfigApi.BASE_URL +
        "frekis/v4/couponCode/createAdvanceBookingCouponCode",
      UPDATE:
        ConfigApi.BASE_URL +
        "frekis/v4/couponCode/editAdvanceBookingCouponCode",
    },
    WAIVER_FORM: {
      LIST: ConfigApi.BASE_URL + "frekis/v6/cloudPanel/listByOperator",
      GET: ConfigApi.BASE_URL + "frekis/v3/smartwaiver/waiverDetail",
    },

    //Old
    SIGNUP_URL: ConfigApi.BASE_URL + "signup",
    CUSTOMER_REVIEW:
      ConfigApi.BASE_URL + "frekis/v5/customerReview/listTypeWise",
    CUSTOMER_REVIEW_CSV:
      ConfigApi.BASE_URL + "frekis/v5/customerReview/reviewListCsvForCloud",
    CUSTOMER_RATING_CSV:
      ConfigApi.BASE_URL + "frekis/v5/customerReview/ratingListCsvForCloud",

    CUSTOMER_LIST: ConfigApi.BASE_URL + "frekis/v6/operator/customers",
    SMTP: ConfigApi.BASE_URL + "frekis/v7/smtp/verify",
    FETCH_SMTP: ConfigApi.BASE_URL + "frekis/v7/smtp/get",
    DELETE_CUSTOMER: ConfigApi.BASE_URL + "frekis/v6/operator/customers/delete",
    IMPORT_EMAIL: ConfigApi.BASE_URL + "frekis/v6/operator/customers/import",
    EDIT_CUSTOMER: ConfigApi.BASE_URL + "frekis/v6/operator/customers/update",
    CONTENT_SEND_NEWSLETTER:
      ConfigApi.BASE_URL + "frekis/v7/newsletter/content",
    SEND_NEWSLETTER: ConfigApi.BASE_URL + "frekis/v7/newsletter/send",
    REGENERATE_IMAGE: ConfigApi.BASE_URL + "frekis/v7/newsletter/image",
    // CUSTOMER_REVIEW: ConfigApi.BASE_URL + "frekis/v6/cloudPanel/customer_review",
    FORGOT_URL: ConfigApi.BASE_URL + "forgotpassword",

    UPDATE_PROFILE: ConfigApi.BASE_URL + "users/update",
    CHANGE_PASSWORD: ConfigApi.BASE_URL + "users/change-password",
    USER_LIST: ConfigApi.BASE_URL + "users/list",
    CHANGE_STATUS: ConfigApi.BASE_URL + "admin/change-user-status",
    GET_DASHBOARD: ConfigApi.BASE_URL + "admin/dashboard",
    DELETE_USER: ConfigApi.BASE_URL + "admin/delete-user",

    TERM_CONDITIONS: {
      GET: ConfigApi.BASE_URL + "term-conditions/get",
      UPDATE: ConfigApi.BASE_URL + "term-conditions/update",
    },
    PRIVACY_POLICY: {
      GET: ConfigApi.BASE_URL + "privacy-policy/get",
      UPDATE: ConfigApi.BASE_URL + "privacy-policy/update",
    },
    HELP_FAQ: ConfigApi.BASE_URL + "faq",
    RULES_RAGULATIONS: ConfigApi.BASE_URL + "rules-ragulations",
    GEOFENCE: {
      LIST: ConfigApi.BASE_URL + "frekis/v5/geoFance/getBoundaryList",
      DETAILS: ConfigApi.BASE_URL + "frekis/v5/geoFance/details",
      CREATE: ConfigApi.BASE_URL + "frekis/v5/geoFance/create",
      UPDATE: ConfigApi.BASE_URL + "frekis/v5/geoFance/update",
      DELETE: ConfigApi.BASE_URL + "frekis/v5/geoFance/delete",
      BOUNDARY_DETAIL: ConfigApi.BASE_URL + "frekis/v5/geoFance/boundaryDetail",

      UPDATE_PARKING_SASSET:
        ConfigApi.BASE_URL + "frekis/v5/geoFance/updateParkingAreaAsset",
    },
    PLUDDA: {
      LIST: ConfigApi.BASE_URL + "frekis/v5/pludda/list",
      DETAILS: ConfigApi.BASE_URL + "frekis/v5/pludda/details",
      UPDATE: ConfigApi.BASE_URL + "frekis/v5/pludda/update",
      CHANGE_STATUS: ConfigApi.BASE_URL + "frekis/operator/update",
    },
    SECRET: {
      GENERATE:
        ConfigApi.BASE_URL + "frekis/v3/cloudPanel/generateOperatorSecret",
      GET: ConfigApi.BASE_URL + "frekis/v3/cloudPanel/getOperatorSecret",
    },
    PARKING_VIOLATION: {
      LIST: ConfigApi.BASE_URL + "frekis/v5/parkingViolation/list",
      GET: ConfigApi.BASE_URL + "frekis/v5/parkingViolation/detail/",
    },
    REQUEST_PAYMENT: {
      EMAIL_GET: ConfigApi.BASE_URL + "frekis/v6/users/",
      POST_REQUEST_PAYMENT:
        ConfigApi.BASE_URL + "frekis/v6/cloudPanel/request_payment/add",
      GET_REQUEST_PAYMENT:
        ConfigApi.BASE_URL + "frekis/v6/cloudPanel/request_payment/list",
      PUT_REQUEST_PAYMENT:
        ConfigApi.BASE_URL + "frekis/v6/cloudPanel/request_payment/update",
      DELETE_REQUEST_PAYMENT:
        ConfigApi.BASE_URL + "frekis/v6/cloudPanel/request_payment/delete/",
    },
    LOCK_ANALYTICS: {
      GET_LOCK_ANALYTICS_DATA:
        ConfigApi.BASE_URL + "frekis/v6/cloudPanel/lock_analytics/",
    },
    TIME_SLOT_DETAIL: {
      GET_SLOT_DETAIL_BY_ID:
        ConfigApi.BASE_URL + "frekis/v6/advance_booking/pack_detail_by_date",
      CREATE_SLOT: ConfigApi.BASE_URL + "frekis/v6/advance_booking/add_slot",
      UPDATE_DELETE_SLOT:
        ConfigApi.BASE_URL +
        "frekis/v6/advance_booking/time_slot_update_delete",
    },
    PAY_LATER_PAYMENTs: {
      GET_LIST:
        ConfigApi.BASE_URL + "frekis/v6/advance_booking/pay_later_user_list",
      UPDATE:
        ConfigApi.BASE_URL + "frekis/v6/advance_booking/update_pending_amount/",
    },
    PACKAGE_ADDON: {
      GET_LIST: ConfigApi.BASE_URL + "frekis/v7/package_addon/list_addon",
      UPLOAD_CSV: ConfigApi.BASE_URL + "frekis/v7/package_addon/upload_csv",
      PACKAGE_LIST:
        ConfigApi.BASE_URL + "frekis/v6/advance_booking/list_for_cloud_panel",
      CREATE: ConfigApi.BASE_URL + "frekis/v7/package_addon/create_addon",
      DELETE: ConfigApi.BASE_URL + "frekis/v7/package_addon/delete_addon",
      EDIT: ConfigApi.BASE_URL + "frekis/v7/package_addon/update_addon",
    },

    LICENSE: {
      CLOUD_PANEL_LIST:
        ConfigApi.BASE_URL + "frekis/v6/license_documents/cloud_panel_list",
      GET_LIST: ConfigApi.BASE_URL + "frekis/v6/license_documents",
      UPDATE:
        ConfigApi.BASE_URL +
        "frekis/v6/license_documents/update_license_status",
    },

    WeatherSettings: {
      GET_WEATHER_DETAILS:
        ConfigApi.BASE_URL + "frekis/v7/weatherSetting/getBasedOnOperatorId",
      CREATE_WEATHER_SETTINGS:
        ConfigApi.BASE_URL + "frekis/v7/weatherSetting/createWeatherSetting",
      UPDATE_WEATHER_SETTINGS:
        ConfigApi.BASE_URL + "frekis/v7/weatherSetting/updateWeatherSetting",
    },

    warningFeature: {
      WARNING_LIST:
        ConfigApi.BASE_URL + "frekis/v7/weatherFeatures/listsForOperator",
      CREATE_WARNING: ConfigApi.BASE_URL + "frekis/v7/weatherFeatures/create",
      DELETE_WARNING: ConfigApi.BASE_URL + "frekis/v7/weatherFeatures/delete",
      UPDATE_WARNING: ConfigApi.BASE_URL + "frekis/v7/weatherFeatures/update",
    },
    VENDING: {
      // LIST: ConfigApi.BASE_URL + "frekis/v7/vendingPackage/list",
      LIST:
        ConfigApi.SERVER_DESIBOX_HOST + "vendingPackage/listWithCategorySort",
      CREATE: ConfigApi.SERVER_DESIBOX_HOST + "vendingPackage/create",
      UPDATE: ConfigApi.SERVER_DESIBOX_HOST + "vendingPackage/update",
      DELETE: ConfigApi.SERVER_DESIBOX_HOST + "vendingPackage/delete",
      UPLOAD_CSV:
        ConfigApi.SERVER_DESIBOX_HOST + "vendingPackage/createWithCsvUpload",

      STORE_LIST: ConfigApi.BASE_URL + "frekis/v7/operatorStore/details",
      CREATE_STORE: ConfigApi.BASE_URL + "frekis/v7/operatorStore/create",
      STORE_CATEGORY_LIST: ConfigApi.BASE_URL + "frekis/v8/storeCategory/list",

      ORDER_LIST: ConfigApi.SERVER_DESIBOX_HOST + "vendingOrder/list",
      TRACK_ORDER:
        ConfigApi.SERVER_DESIBOX_HOST + "vendingOrder/orderDetailsForMerchant",
      UPDATE_ORDER: ConfigApi.SERVER_DESIBOX_HOST + "vendingOrder/updateOrder",
      TOGGLE_FEATURED:
        ConfigApi.SERVER_DESIBOX_HOST +
        "vendingPackage/updateToFeaturedProduct",
      TOGGLE_VISIBILITY:
        ConfigApi.SERVER_DESIBOX_HOST +
        "vendingPackage/updateToVisibilityProduct",
      TOGGLE_CAMPAIGN:
        ConfigApi.SERVER_DESIBOX_HOST +
        "vendingPackage/updateToCampaignProduct",
      TOGGLE_FESTIVE_BOX:
        ConfigApi.SERVER_DESIBOX_HOST + "vendingPackage/updateToFestiveBox",
      UPDATE_TRACKING_ID:
        ConfigApi.BASE_URL +
        "frekis/v7/vendingOrder/addDeliveryServiceTrackingId",
      REFUND_PACKAGE_ITEMS:
        ConfigApi.SERVER_DESIBOX_HOST + "vendingOrder/refundPackageItems",
      READY_FOR_PICKUP:
        ConfigApi.BASE_URL + "frekis/v7/vendingOrder/readyForPickUp",
      OUT_FOR_DELIVERY:
        ConfigApi.BASE_URL + "frekis/v7/vendingOrder/outForDelivery",
      SEARCH_USERS:
        ConfigApi.SERVER_DESIBOX_HOST + "vendingOrder/searchUsersByUsername",
      ORDER_LIST_EXPORT:
        ConfigApi.SERVER_DESIBOX_HOST + "vendingOrder/listForExport",
    },
    OPERATOR_FESTIVAL: {
      LIST: ConfigApi.BASE_URL + "frekis/v7/operatorFestival/listOfFestivals",
      CREATE: ConfigApi.BASE_URL + "frekis/v7/operatorFestival/createFestival",
      UPDATE: ConfigApi.BASE_URL + "frekis/v7/operatorFestival/updateFestival",
      DETAILS:
        ConfigApi.BASE_URL + "frekis/v7/operatorFestival/getFestivalDetails",
      DELETE: ConfigApi.BASE_URL + "frekis/v7/operatorFestival/deleteFestival",
    },
    LOTTERY: {
      LIST: ConfigApi.SERVER_DESIBOX_HOST + "lottery/list",
      CREATE: ConfigApi.SERVER_DESIBOX_HOST + "lottery/create",
      DETAILS: ConfigApi.SERVER_DESIBOX_HOST + "lottery/details",
      UPDATE: ConfigApi.SERVER_DESIBOX_HOST + "lottery/update",
      TOGGLE_STATUS: ConfigApi.SERVER_DESIBOX_HOST + "lottery/toggleStatus",
      DELETE: ConfigApi.SERVER_DESIBOX_HOST + "lottery/delete",
    },
    LOTTERY_PARTICIPATION: {
      LIST: ConfigApi.SERVER_DESIBOX_HOST + "lotteryParticipation/cloud/list",
      DETAILS: ConfigApi.SERVER_DESIBOX_HOST + "lotteryParticipation/cloud/details",
    },
    BOOK_LOCATION: {
      LIST: ConfigApi.BASE_URL + "frekis/v7/bookingLocation/list",
      DETAILS: ConfigApi.BASE_URL + "frekis/v7/bookingLocation/details",
      CREATE: ConfigApi.BASE_URL + "frekis/v7/bookingLocation/createLocation",
      UPDATE: ConfigApi.BASE_URL + "frekis/v7/bookingLocation/update",
      DELETE: ConfigApi.BASE_URL + "frekis/v7/bookingLocation/delete",
      SERVICE_LIST:
        ConfigApi.BASE_URL + "frekis/v7/bookingServiceMaster/listForCloud",
    },

    SPOT_BOOKING: {
      LIST: ConfigApi.BASE_URL + "frekis/v7/spotBooking/listAllSpotBookings",
      CREATE: ConfigApi.BASE_URL + "frekis/v7/spotBooking/createBooking",
      UPDATE: ConfigApi.BASE_URL + "frekis/v7/spotBooking/updateBooking",
      DELETE: ConfigApi.BASE_URL + "frekis/v7/spotBooking/deleteBooking",
      DETAILS: ConfigApi.BASE_URL + "frekis/v7/spotBooking/getBookingDetails",
      BLOCK_SEAT: ConfigApi.BASE_URL + "frekis/v7/spotBooking/updateSlotZone",

      SPOT_CATEGORY_LIST: ConfigApi.BASE_URL + "frekis/v7/spotCategory/list",

      PURCHASE_BOOKING_LIST:
        ConfigApi.BASE_URL + "frekis/v7/spotBookingPurchase/listForOperator",
      PURCHASE_BOOKING_DETAILS:
        ConfigApi.BASE_URL + "frekis/v7/spotBookingPurchase/detailsForOperator",
      REFUND_SPOT_BOOKING:
        ConfigApi.BASE_URL + "frekis/v7/spotBookingPurchase/refundBooking",
      CANCEL_SPOT_BOOKING:
        ConfigApi.BASE_URL +
        "frekis/v7/spotBookingPurchase/cancelBookingRequest",
      REFUND_LIST:
        ConfigApi.BASE_URL +
        "frekis/v7/spotBookingPurchase/cancelSlotListsForOperators",
    },
    MEMBERSHIP: {
      LIST:
        ConfigApi.BASE_URL + "frekis/v7/operatorMembership/listsForOperator",
      DETAILS: ConfigApi.BASE_URL + "frekis/v7/operatorMembership/details",
      CREATE:
        ConfigApi.BASE_URL + "frekis/v7/operatorMembership/createMembership",
      UPDATE:
        ConfigApi.BASE_URL + "frekis/v7/operatorMembership/updateMembership",
      DELETE:
        ConfigApi.BASE_URL + "frekis/v7/operatorMembership/deleteMembership",
      USER_MEMBERSHIP_LIST:
        ConfigApi.BASE_URL + "frekis/v7/userMembership/listForOperator",
      USER_MEMBERSHIP_DETAILS:
        ConfigApi.BASE_URL + "frekis/v7/userMembership/detailsForOperator",
    },
    VENDING_DONATION_TRANSACTION: {
      LIST:
        ConfigApi.BASE_URL +
        "frekis/v7/donationTransactions/listWithPagination",
      DETAILS: ConfigApi.BASE_URL + "frekis/v7/donationTransactions/details",
    },
    VENDING_DONATION_SETTLEMENT: {
      LIST:
        ConfigApi.BASE_URL + "frekis/v7/donationSettlement/listWithPagination",
      DETAILS: ConfigApi.BASE_URL + "frekis/v7/donationSettlement/details",
      UPDATE: ConfigApi.BASE_URL + "frekis/v7/donationSettlement/updateStatus",
      UPDATE_STATUS:
        ConfigApi.BASE_URL +
        "frekis/v7/operatorStore/updateDonationVisibleStatus",
    },
    VENDING_CATEGORY: {
      LIST: ConfigApi.BASE_URL + "frekis/v7/vendingCategory/listWithPagination",
      CREATE: ConfigApi.BASE_URL + "frekis/v7/vendingCategory/create",
      UPDATE: ConfigApi.BASE_URL + "frekis/v7/vendingCategory/update",
      DELETE: ConfigApi.BASE_URL + "frekis/v7/vendingCategory/delete",
      DETAILS: ConfigApi.BASE_URL + "frekis/v7/vendingCategory/details",
      UPLOAD_CATEGORY_CSV:
        ConfigApi.BASE_URL + "frekis/v7/vendingCategory/createWithCsvUpload",
      LIST_WITHOUT_PAGENATION:
        ConfigApi.SERVER_DESIBOX_HOST + "vendingCategory/list",
      VENDING_CATEGORY_PRODUCT_LIST:
        ConfigApi.BASE_URL +
        "frekis/v7/vendingPackage/productListBasedOnCategory",
      UNLINK_PRODUCT_FROM_CATEGORY:
        ConfigApi.BASE_URL +
        "frekis/v7/vendingPackage/unlinkCategoryFromVendingPackage",

      PickupLocationList:
        ConfigApi.BASE_URL + "frekis/v7/operatorStoreAddress/list",
      PickupLocationCreate:
        ConfigApi.BASE_URL + "frekis/v7/operatorStoreAddress/create",
      PickupLocationUpdate:
        ConfigApi.BASE_URL + "frekis/v7/operatorStoreAddress/update",
      PickupLocationDelete:
        ConfigApi.BASE_URL + "frekis/v7/operatorStoreAddress/delete",
    },
    DONATION_MASTER: {
      CREATE: ConfigApi.BASE_URL + "frekis/v7/desiboxDonationMaster/create",
      LIST:
        ConfigApi.BASE_URL +
        "frekis/v7/desiboxDonationMaster/listWithPagination",
      UPDATE: ConfigApi.BASE_URL + "frekis/v7/desiboxDonationMaster/update",
      DETAILS: ConfigApi.BASE_URL + "frekis/v7/desiboxDonationMaster/details",
      DELETE: ConfigApi.BASE_URL + "frekis/v7/desiboxDonationMaster/delete",
    },
    VENDING_SHIPPING_FEATURE: {
      LIST: ConfigApi.BASE_URL + "frekis/v7/storeDeliveryServices/list",
      CREATE: ConfigApi.BASE_URL + "frekis/v7/storeDeliveryServices/create",
      UPDATE: ConfigApi.BASE_URL + "frekis/v7/storeDeliveryServices/update",
      DELETE: ConfigApi.BASE_URL + "frekis/v7/storeDeliveryServices/delete",
      DETAILS: ConfigApi.BASE_URL + "frekis/v7/storeDeliveryServices/details",
    },
    POS: {
      LIST_ORDER: ConfigApi.SERVER_ATZ_HOST + "productPurchase/listOrderCloud",
      ORDER_DETAILS:
        ConfigApi.SERVER_ATZ_HOST + "productPurchase/detailsForCloud/",
      UPDATE_ORDER_STATUS:
        ConfigApi.SERVER_ATZ_HOST +
        "productPurchase/updateOrderStatusForCloud/",
      DASHBOARD_STATISTICS:
        ConfigApi.SERVER_ATZ_HOST +
        "productPurchase/dashboardStatasticsForCloud",
    },
  };
}
